package com.narbase.letsgo.dto

import com.narbase.letsgo.dto.core.KmmLong

actual typealias KmmLong = Double

actual fun kmmLongOf(value: Long): KmmLong {
    return (value as Number).toDouble()
}

 fun Long.tokmmLong(): KmmLong {
    return (this as Number).toDouble()
}
@Deprecated(
    message = "Remove",
    level = DeprecationLevel.WARNING,
    replaceWith = ReplaceWith("")
)
fun KmmLong.tokmmLong(): Nothing {
    TODO()
}
